/**
 * The overlay element.
 */
export interface OverlayElement extends Element {
  /**
   * The overlay parent redirect ID.
   */
  $overlayParentRedirect?: string | null;
}

/**
 * Gets the parent for the specified element.
 * @param element The element to get the parent for.
 * @returns The parent element or null if none found.
 */
export function getParent(element: Element): Element | null {
  let result = element.parentNode;
  if ((result as OverlayElement)?.$overlayParentRedirect) {
    const id = (result as OverlayElement)?.$overlayParentRedirect;
    if (id) result = document.getElementById(id);
  }

  return result as Element;
}
